// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Reset */
body {
  margin: 0;
  font-family: Arial, sans-serif;
}

/* Gallery Container */
.gallery-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 20px;
  margin-top: 70px;
  background-color: #fff7d6;
  margin-bottom: -90px;
}

/* Image Stack */
.image-stack {
  position: relative;
  width: 300px;
  height: 440px;
}

.image-item {
  position: absolute;
  width: 230px;
  height: 160px;
  border-radius: 15px;
  cursor: pointer;
  transition: transform 0.3s, z-index 0.3s, box-shadow 0.3s;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-item:nth-child(1) {
  top: -50px;
  left: 0;
  z-index: 4;
}

.image-item:nth-child(2) {
  top: 80px;
  left: 100px;
  z-index: 3;
}

.image-item:nth-child(3) {
  top: 40px;
  left: -130px;
  z-index: 2;
}

.image-item:nth-child(4) {
  top: 200px;
  left: -10px;
  z-index: 1;
}

.image-item:hover {
  transform: scale(1.1);
  z-index: 5;
}

.image-item.active {
  border: 3px solid #ff5757;
}

/* Info Section */
/* Info Section: Center Align Text on the Right Side */
.info-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center; /* Center-align text */
  margin-left: 60px;
  width: 40%;
  height: 40%;
}

.info-section h2 {
  font-size: 36px;
  color: #d65a07;
  margin-bottom: 30px; /* Adjust spacing */
  margin-left:150px;
}

.info-section p {
  font-size: 18px;
  line-height: 1.5;
  color: #171313;
  margin-bottom: 110px;
  margin-left:150px;
}

/* Modal for Enlarged Image */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.modal-content {
  position: relative;
  text-align: center;
  background: white;
  padding: 20px;
  border-radius: 15px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
  max-width: 90%;
  max-height: 80%;
  overflow: auto;
}

.modal-image {
  max-width: 100%;
  max-height: 400px;
  object-fit: contain;
  border-radius: 15px;
}

.modal-description {
  font-size: 18px;
  color: #333;
  margin-top: 20px;
}






.modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #b4acac;
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
  border-radius: 50%;
}

.modal-close:hover {
  background: #706b6b;
}

/* Second Page Styling */
.second-gallery-container {
  background-color: #f2f2f2;
  padding: 50px 20px;
}

.second-gallery-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/* Second Gallery Section: Left-Side Text Area */
.second-left-info {
  flex: 1 1;
  padding-right: 20px;
  text-align: left; /* Align text to the left */
}

.second-left-info h2 {
  font-size: 36px;
  color: #23c7b1;
  margin-bottom: 20px; /* Add some spacing below the heading */
}

.second-left-info p {
  font-size: 18px;
  line-height: 1.5;
  color: #090c0c;
  margin: 20px 0;
  max-height: 4.5em; /* Adjust based on the line height */
  overflow: hidden; /* Hide overflowed text */
}




.second-right-images {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 columns for layout */
  grid-template-rows: auto auto; /* Automatic height adjustment */
  gap: 20px;
  justify-items: center;
  align-items: center;
}

.second-side-image-container {
  width: 200px;
  height: 200px;
  border-radius: 15px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
}

/* Child-specific sizes for each image */
.second-side-image-container:nth-child(1) {
  width: 240px;
  height: 180px;
  margin-right:-30px;
  border-radius: 30%;
}

.second-side-image-container:nth-child(2) {
  width: 200px;
  height: 190px;
  margin-right:-30px;
  border-radius: 30%;
}

.second-side-image-container:nth-child(3) {
  width: 220px;
  height: 170px;
  margin-bottom: -120px;
  border-radius: 30%;
}

.second-side-image-container:nth-child(4) {
  width: 150px;
  height: 150px;
  border-radius: 30%;
}

.second-side-image-container:nth-child(5) {
  width: 180px;
  height: 140px;
  border-radius: 30%;
}

.second-side-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 15px;
}

.second-side-image-container:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.3);
}



/* Responsive Styling for Mobile View */
@media screen and (max-width: 768px) {
  /* Stack the gallery and info section vertically */
  .gallery-container {
    flex-direction: column; /* Stack elements vertically */
    align-items: center;    /* Center align elements */
    margin: 30px 0;         /* Add spacing */
    
    
  }
  
.image-item:nth-child(1) {
  top: -50px;
  left: 80px;
  width:120px;
  
  z-index: 4;
}

.image-item:nth-child(2) {
  top: 90px;
  left: 120px;
  z-index: 3;
  width:120px;
}

.image-item:nth-child(3) {
  top: 50px;
  left: -10px;
  z-index: 2;
  width:120px;
}

.image-item:nth-child(4) {
  top: 200px;
  left: 50px;
  z-index: 1;
  width:120px;
}


  /* Ensure the image stack is full width */
  .image-stack {
    width: -90%; /* Take full width */
    height: auto; /* Adjust height dynamically */
    margin-bottom:380px; /* Add spacing below */
    margin-top:250px;
    margin-right:-20px;
  }

  /* Ensure the info section is full width */
  .info-section {
    width: 100%; /* Full width */
    margin-bottom: 10px; /* Add spacing below text */
    margin-top:-50px;
    text-align: center; /* Center align text */
  }

  /* Adjust heading and paragraph sizes for better readability */
  .info-section h2 {
    font-size: 20px; /* Adjust font size */
    margin-left: 15px;  /* Reset margin */
    margin-bottom:10px;
  }

  .info-section p {
    font-size: 16px; /* Adjust font size */
    margin-left: 0;  /* Reset margin */
  }

  .second-gallery-content {
    grid-template-columns: 1fr; /* Single column layout */
    gap: 0px; /* Reduce gap for smaller screens */
  }

  .second-side-image-container {
    max-width: 100%; /* Allow full width */
    height: auto; /* Maintain aspect ratio */
  }
}

@media screen and (max-width: 480px) {
  .second-gallery-content {
    flex-direction: column; /* Keep content stacked vertically */
  }

  .second-left-info {
    width: 100%; /* Ensure full width for text */
    text-align: center; /* Center align for better readability */
    margin-bottom: 10px; /* Add spacing below text */
  }

  .second-left-info h2 {
    font-size: 30px;
    color: #23c7b1;
    margin-top: 5px;
  }
.second-left-info p {
  font-size: 15px;
  line-height: 1.5;
  color: #96a3a1;
  margin: 20px 0;
}

  .second-right-images {
    grid-template-columns: 1fr; /* Single column for images */
    gap: 10px; /* Reduce gap for smaller screens */
  }

  .second-side-image-container {
    max-width: 100%; /* Full width images */
    height: auto;
  }
}

@media screen and (max-width: 480px) {
  .second-gallery-content {
    gap: 15px; /* Further reduce gap between text and images */
  }

  .second-left-info {
    margin-bottom: 15px; /* Reduce spacing for smaller screens */
  }

  .second-right-images {
    gap: 15px; /* Reduce gap between images */
  }

  .second-side-image-container:nth-child(4)
  {
    margin-top: 120px;
  }
  .second-side-image-container:nth-child(5)
  {
    margin-top: 10px;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/Gallery/Gallery.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yDAAyD;EACzD,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB,sDAAsD;AACtD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB,EAAE,sBAAsB;EAC1C,iBAAiB;EACjB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB,EAAE,mBAAmB;EACxC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;;;;;;AAOA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA,gDAAgD;AAChD;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB,EAAE,2BAA2B;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB,EAAE,uCAAuC;AAC9D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,iBAAiB,EAAE,oCAAoC;EACvD,gBAAgB,EAAE,yBAAyB;AAC7C;;;;;AAKA;EACE,aAAa;EACb,qCAAqC,EAAE,yBAAyB;EAChE,6BAA6B,EAAE,gCAAgC;EAC/D,SAAS;EACT,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA,wCAAwC;AACxC;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;;;AAIA,uCAAuC;AACvC;EACE,kDAAkD;EAClD;IACE,sBAAsB,EAAE,8BAA8B;IACtD,mBAAmB,KAAK,0BAA0B;IAClD,cAAc,UAAU,gBAAgB;;;EAG1C;;AAEF;EACE,UAAU;EACV,UAAU;EACV,WAAW;;EAEX,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,UAAU;EACV,UAAU;EACV,WAAW;AACb;;;EAGE,yCAAyC;EACzC;IACE,WAAW,EAAE,oBAAoB;IACjC,YAAY,EAAE,8BAA8B;IAC5C,mBAAmB,EAAE,sBAAsB;IAC3C,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,0CAA0C;EAC1C;IACE,WAAW,EAAE,eAAe;IAC5B,mBAAmB,EAAE,2BAA2B;IAChD,gBAAgB;IAChB,kBAAkB,EAAE,sBAAsB;EAC5C;;EAEA,8DAA8D;EAC9D;IACE,eAAe,EAAE,qBAAqB;IACtC,iBAAiB,GAAG,iBAAiB;IACrC,kBAAkB;EACpB;;EAEA;IACE,eAAe,EAAE,qBAAqB;IACtC,cAAc,GAAG,iBAAiB;EACpC;;EAEA;IACE,0BAA0B,EAAE,yBAAyB;IACrD,QAAQ,EAAE,mCAAmC;EAC/C;;EAEA;IACE,eAAe,EAAE,qBAAqB;IACtC,YAAY,EAAE,0BAA0B;EAC1C;AACF;;AAEA;EACE;IACE,sBAAsB,EAAE,oCAAoC;EAC9D;;EAEA;IACE,WAAW,EAAE,+BAA+B;IAC5C,kBAAkB,EAAE,wCAAwC;IAC5D,mBAAmB,EAAE,2BAA2B;EAClD;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;EACjB;AACF;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;EAEE;IACE,0BAA0B,EAAE,6BAA6B;IACzD,SAAS,EAAE,mCAAmC;EAChD;;EAEA;IACE,eAAe,EAAE,sBAAsB;IACvC,YAAY;EACd;AACF;;AAEA;EACE;IACE,SAAS,EAAE,+CAA+C;EAC5D;;EAEA;IACE,mBAAmB,EAAE,uCAAuC;EAC9D;;EAEA;IACE,SAAS,EAAE,8BAA8B;EAC3C;;EAEA;;IAEE,iBAAiB;EACnB;EACA;;IAEE,gBAAgB;EAClB;;AAEF","sourcesContent":["/* General Reset */\nbody {\n  margin: 0;\n  font-family: Arial, sans-serif;\n}\n\n/* Gallery Container */\n.gallery-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  padding: 20px;\n  margin-top: 70px;\n  background-color: #fff7d6;\n  margin-bottom: -90px;\n}\n\n/* Image Stack */\n.image-stack {\n  position: relative;\n  width: 300px;\n  height: 440px;\n}\n\n.image-item {\n  position: absolute;\n  width: 230px;\n  height: 160px;\n  border-radius: 15px;\n  cursor: pointer;\n  transition: transform 0.3s, z-index 0.3s, box-shadow 0.3s;\n  overflow: hidden;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n.image-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.image-item:nth-child(1) {\n  top: -50px;\n  left: 0;\n  z-index: 4;\n}\n\n.image-item:nth-child(2) {\n  top: 80px;\n  left: 100px;\n  z-index: 3;\n}\n\n.image-item:nth-child(3) {\n  top: 40px;\n  left: -130px;\n  z-index: 2;\n}\n\n.image-item:nth-child(4) {\n  top: 200px;\n  left: -10px;\n  z-index: 1;\n}\n\n.image-item:hover {\n  transform: scale(1.1);\n  z-index: 5;\n}\n\n.image-item.active {\n  border: 3px solid #ff5757;\n}\n\n/* Info Section */\n/* Info Section: Center Align Text on the Right Side */\n.info-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center; /* Center-align text */\n  margin-left: 60px;\n  width: 40%;\n  height: 40%;\n}\n\n.info-section h2 {\n  font-size: 36px;\n  color: #d65a07;\n  margin-bottom: 30px; /* Adjust spacing */\n  margin-left:150px;\n}\n\n.info-section p {\n  font-size: 18px;\n  line-height: 1.5;\n  color: #171313;\n  margin-bottom: 110px;\n  margin-left:150px;\n}\n\n/* Modal for Enlarged Image */\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n}\n\n.modal-content {\n  position: relative;\n  text-align: center;\n  background: white;\n  padding: 20px;\n  border-radius: 15px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);\n  max-width: 90%;\n  max-height: 80%;\n  overflow: auto;\n}\n\n.modal-image {\n  max-width: 100%;\n  max-height: 400px;\n  object-fit: contain;\n  border-radius: 15px;\n}\n\n.modal-description {\n  font-size: 18px;\n  color: #333;\n  margin-top: 20px;\n}\n\n\n\n\n\n\n.modal-close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: #b4acac;\n  color: white;\n  border: none;\n  padding: 10px;\n  cursor: pointer;\n  border-radius: 50%;\n}\n\n.modal-close:hover {\n  background: #706b6b;\n}\n\n/* Second Page Styling */\n.second-gallery-container {\n  background-color: #f2f2f2;\n  padding: 50px 20px;\n}\n\n.second-gallery-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n/* Second Gallery Section: Left-Side Text Area */\n.second-left-info {\n  flex: 1;\n  padding-right: 20px;\n  text-align: left; /* Align text to the left */\n}\n\n.second-left-info h2 {\n  font-size: 36px;\n  color: #23c7b1;\n  margin-bottom: 20px; /* Add some spacing below the heading */\n}\n\n.second-left-info p {\n  font-size: 18px;\n  line-height: 1.5;\n  color: #090c0c;\n  margin: 20px 0;\n  max-height: 4.5em; /* Adjust based on the line height */\n  overflow: hidden; /* Hide overflowed text */\n}\n\n\n\n\n.second-right-images {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr); /* 3 columns for layout */\n  grid-template-rows: auto auto; /* Automatic height adjustment */\n  gap: 20px;\n  justify-items: center;\n  align-items: center;\n}\n\n.second-side-image-container {\n  width: 200px;\n  height: 200px;\n  border-radius: 15px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: transform 0.3s, box-shadow 0.3s;\n}\n\n/* Child-specific sizes for each image */\n.second-side-image-container:nth-child(1) {\n  width: 240px;\n  height: 180px;\n  margin-right:-30px;\n  border-radius: 30%;\n}\n\n.second-side-image-container:nth-child(2) {\n  width: 200px;\n  height: 190px;\n  margin-right:-30px;\n  border-radius: 30%;\n}\n\n.second-side-image-container:nth-child(3) {\n  width: 220px;\n  height: 170px;\n  margin-bottom: -120px;\n  border-radius: 30%;\n}\n\n.second-side-image-container:nth-child(4) {\n  width: 150px;\n  height: 150px;\n  border-radius: 30%;\n}\n\n.second-side-image-container:nth-child(5) {\n  width: 180px;\n  height: 140px;\n  border-radius: 30%;\n}\n\n.second-side-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 15px;\n}\n\n.second-side-image-container:hover {\n  transform: scale(1.05);\n  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.3);\n}\n\n\n\n/* Responsive Styling for Mobile View */\n@media screen and (max-width: 768px) {\n  /* Stack the gallery and info section vertically */\n  .gallery-container {\n    flex-direction: column; /* Stack elements vertically */\n    align-items: center;    /* Center align elements */\n    margin: 30px 0;         /* Add spacing */\n    \n    \n  }\n  \n.image-item:nth-child(1) {\n  top: -50px;\n  left: 80px;\n  width:120px;\n  \n  z-index: 4;\n}\n\n.image-item:nth-child(2) {\n  top: 90px;\n  left: 120px;\n  z-index: 3;\n  width:120px;\n}\n\n.image-item:nth-child(3) {\n  top: 50px;\n  left: -10px;\n  z-index: 2;\n  width:120px;\n}\n\n.image-item:nth-child(4) {\n  top: 200px;\n  left: 50px;\n  z-index: 1;\n  width:120px;\n}\n\n\n  /* Ensure the image stack is full width */\n  .image-stack {\n    width: -90%; /* Take full width */\n    height: auto; /* Adjust height dynamically */\n    margin-bottom:380px; /* Add spacing below */\n    margin-top:250px;\n    margin-right:-20px;\n  }\n\n  /* Ensure the info section is full width */\n  .info-section {\n    width: 100%; /* Full width */\n    margin-bottom: 10px; /* Add spacing below text */\n    margin-top:-50px;\n    text-align: center; /* Center align text */\n  }\n\n  /* Adjust heading and paragraph sizes for better readability */\n  .info-section h2 {\n    font-size: 20px; /* Adjust font size */\n    margin-left: 15px;  /* Reset margin */\n    margin-bottom:10px;\n  }\n\n  .info-section p {\n    font-size: 16px; /* Adjust font size */\n    margin-left: 0;  /* Reset margin */\n  }\n\n  .second-gallery-content {\n    grid-template-columns: 1fr; /* Single column layout */\n    gap: 0px; /* Reduce gap for smaller screens */\n  }\n\n  .second-side-image-container {\n    max-width: 100%; /* Allow full width */\n    height: auto; /* Maintain aspect ratio */\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .second-gallery-content {\n    flex-direction: column; /* Keep content stacked vertically */\n  }\n\n  .second-left-info {\n    width: 100%; /* Ensure full width for text */\n    text-align: center; /* Center align for better readability */\n    margin-bottom: 10px; /* Add spacing below text */\n  }\n\n  .second-left-info h2 {\n    font-size: 30px;\n    color: #23c7b1;\n    margin-top: 5px;\n  }\n.second-left-info p {\n  font-size: 15px;\n  line-height: 1.5;\n  color: #96a3a1;\n  margin: 20px 0;\n}\n\n  .second-right-images {\n    grid-template-columns: 1fr; /* Single column for images */\n    gap: 10px; /* Reduce gap for smaller screens */\n  }\n\n  .second-side-image-container {\n    max-width: 100%; /* Full width images */\n    height: auto;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .second-gallery-content {\n    gap: 15px; /* Further reduce gap between text and images */\n  }\n\n  .second-left-info {\n    margin-bottom: 15px; /* Reduce spacing for smaller screens */\n  }\n\n  .second-right-images {\n    gap: 15px; /* Reduce gap between images */\n  }\n\n  .second-side-image-container:nth-child(4)\n  {\n    margin-top: 120px;\n  }\n  .second-side-image-container:nth-child(5)\n  {\n    margin-top: 10px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
